export const GET_ESCALATION_STATES = "GET_ESCALATION_STATES";
export const UPDATE_ESCALATION_STATES = "UPDATE_ESCALATION_STATES";
export const GET_ESCALATION_RECORDS = "GET_ESCALATION_RECORDS";